import base from './base'

export const passwordApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    //Envia link para troca de senha
    sendPasswordLink: builder.mutation<{ message: string }, { email: string }>({
      query: (body) => ({ url: 'sendresetlink', method: 'POST', body }),
      //   transformResponse: (res: Res<ClassroomTeacher[]>) => res.data,
    }),

    //Troca a senha do usuário
    resetPassword: builder.mutation<
      { message: string },
      { email: string; password: string; password_confirmation: string; token: string }
    >({
      query: (body) => ({ url: 'resetpassword', method: 'POST', body }),
    }),
  }),
})

export const validationsResetPassword = {
  email: { required: 'Preencha o seu código de usuário' },
  password: { required: 'Preencha o campo senha' },
  password_confirmation: { required: 'Preencha o campo senha' },
}

export const { useResetPasswordMutation, useSendPasswordLinkMutation } = passwordApi
